import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { fontStyles } from "../../../../Component/style/common_font";
import {
  BackgroundArea,
  CenterView,
} from "../../../../Component/style/common_style";

const No_stock = ({ visible, handleModal }: modalProps) => {
  return (
    <BackgroundArea style={visible ? {} : { display: "none" }}>
      <ModalBox className="col">
        <div className="title">재고가 부족합니다.</div>
        <div className="info">해당 방송에서 재고를 수정해주세요.</div>

        <BtnArea onClick={() => handleModal()}>확인</BtnArea>
      </ModalBox>
    </BackgroundArea>
  );
};

export default No_stock;

const ModalBox = styled(CenterView)`
  box-sizing: border-box;
  width: 100%;
  max-width: 18rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 4rem 1rem 1rem 1rem;
  div.title {
    margin-bottom: 1rem;
    ${fontStyles.semiBold}
    font-size: 18px;
    text-align: center;
  }
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
  }
`;
const BtnArea = styled.div`
  width: 100%;
  margin-top: 3rem;
  padding: 0.8rem 0rem;
  ${fontStyles.medium};
  text-align: center;
  color: #8e8e8e;
  border-radius: 8px;
  color: white;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  cursor: pointer;
`;
